import type { ReactElement } from 'react';
import loadable from '@loadable/component';

import { Wrapper } from './styled';

const WatchlistAddRemoveCompanyToggle = loadable(
  () => import('@/components/WatchlistAddRemoveCompanyToggle')
);

interface Props {
  companyId: string;
  tickerSymbol: string;
  dropdownRender?: () => ReactElement;
}

const WatchlistSidebarActions = ({
  companyId,
  tickerSymbol,
  dropdownRender,
}: Props) => {
  return (
    <Wrapper data-cy-id="watchlist-sidebar">
      <WatchlistAddRemoveCompanyToggle
        companyId={companyId}
        tickerSymbol={tickerSymbol}
      />
      {typeof dropdownRender === 'function' ? dropdownRender() : null}
    </Wrapper>
  );
};

export default WatchlistSidebarActions;
